export const valFromStorage = <T>(storageKey: string, defaultVal: T): T => {
  const val = window.localStorage.getItem(storageKey);
  if (val) {
    return JSON.parse(val) as T;
  }
  return defaultVal;
};
